var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{},[_c('Header',{staticClass:"sticky top-0 z-50"}),_c('main',{staticClass:"relative bg-white"},[_c('div',{},[_vm._t("default")],2)]),(_vm.$route.name === 'main')?_c('Footer'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }